import { reactive } from 'vue';
import { $g } from './global';
export const api = reactive({
    login: 'login',
    logout: 'logout',
    register: 'register',
    refresh: 'oauth/refresh',
    authorize: 'oauth/{socialite}/login',
    captcha: {
        init: 'captcha/init',
        verify: 'captcha/verify'
    },
    email: {
        active: 'email/active/{token}',
        resend: 'email/active/resend'
    },
    validator: {
        name: 'validator/name',
        email: 'validator/email',
        user: 'validator/user'
    },
    password: {
        reset: 'password/reset',
        captcha: 'password/captcha/send',
        check: 'password/captcha/checkout'
    },
    languages: {
        data: 'languages',
        batchCreate: 'languages/batch',
        update: 'languages/{id}',
        check: 'languages/checkout',
        category: {
            data: 'languages/categories',
            update: 'languages/categories/{id}',
            check: 'languages/categories/checkout',
            default: 'languages/categories/default/{id}'
        }
    },
    menus: {
        data: 'menus',
        update: 'menus/{id}',
        delete: 'menus/{id}'
    },
    apps: {
        data: 'apps',
        create: 'apps',
        update: 'apps/{id}',
        delete: 'apps/{id}',
        images: 'images'
    }
});
class MiApi {
    version;
    constructor() {
        this.version = $g.apiVersion;
        this.parse();
    }
    parse(_api) {
        if (this.version) {
            _api = _api ?? api;
            for (const i in _api) {
                if (Object.prototype.hasOwnProperty.call(_api, i)) {
                    if (typeof _api[i] === 'object' && Object.keys(_api[i]).length > 0) {
                        this.parse(_api[i]);
                    }
                    else {
                        const reg = $g.regExp.url;
                        if (!reg.test(_api[i]) && this.version) {
                            _api[i] =
                                _api[i].indexOf(`${this.version}/`) !== -1
                                    ? _api[i]
                                    : `${this.version}/${_api[i]}`;
                        }
                    }
                }
            }
        }
    }
}
export const $api = new MiApi();
export default {
    install(app) {
        app.config.globalProperties.$api = $api;
        app.config.globalProperties.api = api;
        app.provide('$api', $api);
        app.provide('api', api);
        return app;
    }
};
